import { render, staticRenderFns } from "./MaterialsPage.vue?vue&type=template&id=6973b1b9&"
import script from "./MaterialsPage.vue?vue&type=script&lang=js&"
export * from "./MaterialsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports